export default {
    // nshop fast testfast jinsi hktest
    // baseUrl: 'https://beta.betate.com/testfast/public/',
    // baseUrl: 'https://www.blossom-power.com/fast/public/',
    baseUrl: 'https://www.advance-stationery.com/fast/public/',
	// baseUrl: 'http://hk.kkit.cc/hktest/public/',
    //#baseUrl: 'http://www.advancev2.com/public/',
	// baseUrl: 'http://127.0.0.1/fast/public/',
	
    // baseUrl: 'fast/public/',
    // imgUrl: 'https://beta.betate.com/testfast/public/',
	imgUrl: 'https://www.advance-stationery.com/fast/public/',
    // imgUrl: 'https://www.blossom-power.com/fast/public/',
    //#imgUrl: 'http://www.advancev2.com/public/',
    // imgUrl: 'http://127.0.0.1/fast/public/',
	
    // imgUrl: 'fast/public',
}